export default __webpack_public_path__ + "static/cover-norsk-c2efab6ef36248e3adc9773c17fd850d.png";